
import type { PropType } from 'vue'
import { defineComponent  } from 'vue'

// types
import type { Standard2025TariffsMappedStandardParam } from '@/core/types/billing.types'

export default defineComponent({
    props: {
        standardParams: {
            type: Array as PropType<Array<Standard2025TariffsMappedStandardParam>>,
            default: () => []
        }
    }
})
